var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('NavHeader',{ref:"header"}),_c('div',{staticStyle:{"padding-top":"90px"}},[_c('router-view',{on:{"userLogin":_vm.handleUserLogin}})],1),_c('PageFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }